import { render, staticRenderFns } from "./AccueilSurnombre.vue?vue&type=template&id=75826310"
import script from "./AccueilSurnombre.vue?vue&type=script&lang=js"
export * from "./AccueilSurnombre.vue?vue&type=script&lang=js"
import style0 from "./AccueilSurnombre.vue?vue&type=style&index=0&id=75826310&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports